import React from "react";
import {Box, Button, Card, Container} from "@mui/material";
import {PrintOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

/**
 * Sticky print toolbar for purchase print views (no promotion controls).
 */
const PrintPurchaseHeaderToolbar = () => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.print.purchase'});

    return (
        <Container maxWidth={'lg'} className={'d-print-none'} sx={{position: 'sticky', top: 10, zIndex: 100}}>
            <Card variant={'outlined'} sx={{backgroundColor: 'background.paper'}}>
                <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 2, width: '100%'}}>
                    <Button
                        variant={'contained'}
                        onClick={() => window.print()}
                        size={'small'}
                        startIcon={<PrintOutlined/>}
                    >
                        {t('toolbar.print')}
                    </Button>
                </Box>
            </Card>
        </Container>
    );
};

export default PrintPurchaseHeaderToolbar;
